import { ViewModel,View } from "binder"
import { getAsNumber } from "src/uicomponents/components/utilities";
import { IDefaultValueManipulator } from "../defaultValueManipulator";
import  { ServerSideDataLoaderView } from "./serverSideDataLoader-view"

export class ServerSideDataLoaderViewModel extends ViewModel  implements IDefaultValueManipulator{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new ServerSideDataLoaderView();
    }
    public getTypeId(): string {
        return "VM-81AF08DE-C5F9-40CC-A8D9-892B36AC0D39"
    }
    public set functionName(v: string) { this._functionName = v; } public get functionName(): string { return this._functionName;} private _functionName: string;
    public set pageSize(v: number) { this._pageSize = getAsNumber(v); } public get pageSize(): number { return this._pageSize;} private _pageSize: number;
    
    setDefaultValue(defaultValue: any): void {
        this.functionName = defaultValue?.FunctionName ?? "";
        this.pageSize = defaultValue?.PageSize ?? 15;
    }
    getDefaultValue() {
        return {
            FunctionName : this.functionName,
            PageSize : this.pageSize
        }
    }

}
